import React from 'react'
import styled from 'styled-components'
import { node, string, bool } from 'prop-types'
import classnames from 'classnames'

import * as spacing from 'styles/spacing'
import { stripUnit } from 'polished'
import { media } from 'styles/media'

const Container = styled.div`
  padding-left: ${stripUnit(spacing.medium) * 0.75 + 'px'};
  padding-right: ${stripUnit(spacing.medium) * 0.75 + 'px'};
  margin-bottom: ${spacing.large};

  ${media.medium`
    padding-left: ${spacing.medium};
    padding-right: ${spacing.medium};
    margin-bottom: ${spacing.xLarge};
  `};
`

const GridItem = ({ xs, sm, md, lg, xlg, equalHeight, className, children }) => (
  <Container
    className={classnames(className, equalHeight && 'u-flex', {
      [`u-${xs}`]: xs,
      [`u-${sm}-sm`]: sm,
      [`u-${md}-md`]: md,
      [`u-${lg}-lg`]: lg,
      [`u-${xlg}-xlg`]: xlg
    })}
  >
    {children}
  </Container>
)

GridItem.propTypes = {
  children: node.isRequired,
  xs: string.isRequired,
  sm: string,
  md: string,
  lg: string,
  xlg: string,
  className: string,
  equalHeight: bool
}

export default GridItem
